var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('v-toolbar',{attrs:{"color":"white info--text","dark":"","flat":""}},[_c('h1',{staticClass:"info--text"},[_vm._v(_vm._s(_vm.fTitleForm))]),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }